import React, { FC, useContext, useMemo } from 'react';
import { Button } from 'ncoded-component-library';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import EnterpriseMembersContext from 'providers/EnterpriseMembers/EnterpriseMembers.context';
import AddProfileIcon from 'icons/AddProfile.icon';
import UploadIcon from 'icons/Upload.icon';
import AddBulkMembersModal from './AddBulkMembersModal';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import NumberOfResultsPerPageFilter from 'components/NumberOfResultsPerPageFilter';
import { MoreDropdown } from 'router/subrouters/Dash/subrouters/private/subrouters/Portfolio/components/MoreDropdown';
import ChevrondownIcon from 'icons/Chevrondown.icon';

import './ManagePeopleActions.styles.scss';
import './ManagePeopleActions.styles.responsive.scss';

export type ManagePeopleActionsProps = {
  className?: string;
  showLimit?: boolean;
  manageColumns?: React.ReactNode;
};

const ManagePeopleActions: FC<ManagePeopleActionsProps> = (props) => {
  const { className, showLimit, manageColumns } = props;

  const { isLoadingAddMember, limit, handleAddPeople, updateLimit } =
    useContext(EnterpriseMembersContext);

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  const classes = classNames('manage-people-actions', className);

  const { t } = useTranslation();

  const addMembersOptions = useMemo(
    () => [
      {
        label: 'addMembersInBulk',
        disabled: isLoadingAddMember,
        icon: UploadIcon,
        onClick: modal?.open,
      },
      {
        label: 'addAMember',
        disabled: isLoadingAddMember,
        icon: AddProfileIcon,
        onClick: handleAddPeople,
      },
    ],
    [modal, isLoadingAddMember, handleAddPeople],
  );

  return (
    <div className={classes}>
      {showLimit && (
        <NumberOfResultsPerPageFilter limit={limit} updateLimit={updateLimit} />
      )}
      {manageColumns}
      <MoreDropdown
        options={addMembersOptions}
        trigger={
          <Button icon={ChevrondownIcon} iconPosition="right">
            {t('addMembers')}
          </Button>
        }
      />
      <AddBulkMembersModal ref={modalRef} />
    </div>
  );
};

export default ManagePeopleActions;
